import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-electrotherapy',
  templateUrl: './electrotherapy.component.html',
  styleUrls: ['./electrotherapy.component.scss']
})
export class ElectrotherapyComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnBackClick = function () {
    this.router.navigateByUrl('/treatments');
  }

}
